import React from 'react';
import { ChevronLeft, ChevronRight } from '../../icons';
import { Center, Flex, Icon } from '..';
const Arrow = (props)=>{
    const { icon: ArrowIcon , onClick , disabled  } = props;
    const strokeColor = disabled ? 'stroke.light' : 'stroke.interactive';
    return /*#__PURE__*/ React.createElement(Center, {
        as: "button",
        borderColor: strokeColor,
        borderRadius: "full",
        borderWidth: "2px",
        cursor: disabled ? 'not-allowed' : 'pointer',
        h: "2.25rem",
        w: "2.25rem",
        ...!disabled && {
            onClick
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        as: ArrowIcon,
        boxSize: "24px",
        stroke: strokeColor
    }));
};
export const NavArrows = (props)=>{
    const { hasNext , hasPrev , onNext , onPrev , ...flexProps } = props;
    return /*#__PURE__*/ React.createElement(Flex, {
        gap: 1,
        ...flexProps
    }, /*#__PURE__*/ React.createElement(Arrow, {
        disabled: !hasPrev,
        icon: ChevronLeft,
        onClick: onPrev
    }), /*#__PURE__*/ React.createElement(Arrow, {
        disabled: !hasNext,
        icon: ChevronRight,
        onClick: onNext
    }));
};

//# sourceMappingURL=nav-arrows.js.map